import React from 'react'
import { BsX } from 'react-icons/bs';
import { RiDrizzleLine } from 'react-icons/ri';
import { SiNextdotjs, SiPostgresql, SiPrisma } from 'react-icons/si';
import styles from '../componentsStyles/NewCardsComponent.module.css';

const NewCardsComponent = () => {
  return (
    <div className={styles.newCardsComponent}>

       <div className={styles.cardsArea}>
            <input type="radio" name='card' id='cardcb' className={styles.Cardcb}/>
            <input type="radio" name ='card' id="cardcb1" className={styles.cbCard1}/>
            <label className={`${styles.cardWrapper} ${styles.cardWrapper1}`} htmlFor='cardcb1'>
                <div  className={`${styles.card} ${styles.card1}`} >
                    
                    <div className={styles.cardFront}>

                        <div className={styles.top} >
                            <SiNextdotjs className={styles.smallIcon}/>
                        </div>

                        <SiNextdotjs className ={styles.icon}/>
                        <h3>Next.js</h3>

                        <div className={styles.botton}>
                            <SiNextdotjs className={styles.smallIcon}/>
                        </div>

                    </div>

                    <div className={styles.cardback}>
                        <div className={styles.top} >
                            <SiNextdotjs className={styles.smallIcon}/>
                            <label htmlFor="cardcb"><BsX className={styles.closeIcon}/></label>
                        </div>
                        
                        <div className={styles.cardText}>
                          <p>
                           React.js framework  with integrated back-end capabilities.
                          </p>
                          <p>
                            Faster for development, using server components and caaring out common React client components too.
                          </p>  
                        </div>
                        
                        

                        <div className={styles.botton}>
                            <SiNextdotjs className={styles.smallIcon}/>
                        </div>
                    </div>

                </div>
            </label>


           
            <input type="radio" name ='card' id="cardcb2" className={styles.cbCard2}/>
            <label htmlFor='cardcb2' className={`${styles.cardWrapper} ${styles.cardWrapper2}`}>
                <div className={`${styles.card} ${styles.card2}`}>
                    
                    <div className={styles.cardFront}>

                        <div className={styles.top}>
                            <SiPostgresql className={styles.smallIcon}/>
                        </div>
                        <SiPostgresql className ={styles.icon}/>
                        <h3>PostgresSQL</h3>
                        <div className={styles.botton}>
                            <SiPostgresql className={styles.smallIcon}/>
                        </div>

                    </div>

                    <div className={styles.cardback}>

                        <div className={styles.top} >
                            <SiPostgresql className={styles.smallIcon}/>
                            <label htmlFor="cardcb"><BsX className={styles.closeIcon}/></label>
                        </div>
                        
                        <div className={styles.cardText}>
                          <p>
                           A robust data base SQL based, fast and easy to work with.
                          </p>
                          <p>
                          Good for creating relational databases, enforcing constraints that keep tables organized
                          </p>  
                        </div>
                        
                        <div className={styles.botton}>
                            <SiPostgresql className={styles.smallIcon}/>
                        </div>

                    </div>

                </div>

            </label>
           
            <input type="radio" name ='card' id="cardcb3" className={styles.cbCard3}/>
            <label htmlFor='cardcb3' className={`${styles.cardWrapper} ${styles.cardWrapper3}`}>
                <div className={`${styles.card} ${styles.card3}`}>

                    <div className={styles.cardFront}>
                        <div className={styles.top}>
                            <SiPrisma className={styles.smallIcon}/>
                        </div>
                        <SiPrisma className ={styles.icon}/>
                        <h3>Prisma</h3>
                        <div className={styles.botton}>
                            <SiPrisma className={styles.smallIcon}/>
                        </div>
                    </div>

                    <div className={styles.cardback}>

                        <div className={styles.top} >
                            <SiPrisma className={styles.smallIcon}/>
                            <label htmlFor="cardcb"><BsX className={styles.closeIcon}/></label>
                        </div>
                        
                        <div className={styles.cardText}>
                          <p>
                           The most popular ORM to interact with SQL based databases using TypeScript code.
                          </p>
                          <p>
                          Faster to develop and overall a great tool to design queries and create database schemas.
                          </p>  
                        </div>
                        
                        <div className={styles.botton}>
                            <SiPrisma className={styles.smallIcon}/>
                        </div>

                    </div>

                </div>
            </label>
           
            <input type="radio" name ='card' id="cardcb4" className={styles.cbCard4}/>
            <label htmlFor='cardcb4' className={`${styles.cardWrapper} ${styles.cardWrapper4}`}>
                <div className={`${styles.card} ${styles.card4}`}>
                    
                    <div className={styles.cardFront}>
                        <div className={styles.top}>
                            <RiDrizzleLine className={styles.smallIcon}/>
                        </div>
                        <RiDrizzleLine className ={styles.icon}/>
                        <h3>Drizzle</h3>
                        <div className={styles.botton}>
                            <RiDrizzleLine className={styles.smallIcon}/>
                        </div>
                    </div>

                    <div className={styles.cardback}>

                        <div className={styles.top} >
                            <RiDrizzleLine className={styles.smallIcon}/>
                            <label htmlFor="cardcb"><BsX className={styles.closeIcon}/></label>
                        </div>
                        
                        <div className={styles.cardText}>
                          <p>
                           Other ORM to use SQL based databases with TypeScript code.
                          </p>
                          <p>
                          Very light weight tool, deliver a fast performace and a good development experience.
                          </p>  
                        </div>
                        
                        <div className={styles.botton}>
                            <RiDrizzleLine className={styles.smallIcon}/>
                        </div>

                    </div>


                </div>
            </label>    
       </div>
    
    
    </div>
  )
}

export default NewCardsComponent